module.exports = __webpack_public_path__ + "img/cash.df1a07ab.svg";